<div class="flex flex-col items-center w-full">

    <!-- Zone caméra -->
    <div class="relative w-[315px] h-[389px] bg-black rounded-md overflow-hidden shadow-lg">

        <video #videoElement autoplay playsinline muted
            class="w-full h-full object-cover">
        </video>

        <!-- Cadre de visée -->
        @if (cameraReady) {
        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div class="w-48 h-48 border-4 border-green-400/80 rounded-lg"></div>
        </div>
        }

        <!-- Erreur caméra -->
        @if (cameraError) {
        <div class="absolute inset-0 flex flex-col items-center justify-center bg-gray-800 text-white p-4 text-center">
            <i class="fas fa-video-slash text-4xl mb-3 text-red-400"></i>
            <p class="text-sm">{{ 'vues.ipad.scan.camera-error' | translate }}</p>
        </div>
        }

    </div>

    <p class="mt-4 text-sm text-blue-600 text-center">{{ 'vues.ipad.scan.instructions' | translate }}</p>

</div>
